import React, { Component } from "react";
import { Card, Button, Modal, ModalHeader, ModalBody, Input, ModalFooter, Table, CardBody, Row, Col } from "reactstrap";
import SliderPublishers from '../../components/Products/SliderPublishers';
import { Link } from "react-router-dom";
import * as actionCreator from '../../store/action/index';
import { connect } from 'react-redux';
import {LoadingSliderAdmin} from '../../components/UI/LoadingData/ProductList/Loadingdata';
import InfiniteScroll from '../../components/InfinityScroller';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import SpinnerGif from "../../assets/img/spinner-loading.gif";

import icons from "../../variables/icons";
import axios from "axios";

import {
    getSliderPublisher,
    CreateSliderPublisher,
    updateSliderPublisher,
    deleteSliderPublisher,
} from '../../api/index';

class SliderPublisher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderpublishers: [],
      loadingdata: true,
      modal: false,
      page: 1,
      limit: 5,            
      name: null,
      hasMoreItems: true,
      count: null,
      maxPages: null,
      isFetching:false,
      typingTimeout:0,
      delete_sliderpublisher: {
        id: null,
        name: "",
        picture_url: "",
        hyperlink: ""
      }
    }
  }


  loadSliderPublisher = (page) => { 
    const nextPage = page || this.state.page;

    const content = {
      page: page ? page : 1,
      limit: this.state.limit,
      companyId: this.props.ui?.companyId || 1,
       name: "Slider Publisher"
    }

    getSliderPublisher(content).then(res => {
      // const sliderpublishers = res.result.map((value) => ({
      const newData = res.result.map((value) => ({
      id: value.id,
      name: value.name,
      hyperlink: value.hyperlink,
      slidebar: value.slidebar,   
      companyId: value.companyId,
      order: value.order,
    }));
  
      this.setState(prev=> ({
        sliderpublishers: [...prev.sliderpublishers, ...newData],
        count: res.count,
        maxPages: res.pages,
        loadingdata: false,
        page: nextPage + 1,
        hasMoreItems: nextPage < res.pages,

      }));

      if (content.page == this.state.maxPages) {       
        this.setState({ hasMoreItems: false });
      }
      this.props.setLoading(false)      
    });
  }

  componentDidMount() {
    window.scrollTo(0,0);
    this.loadSliderPublisher();    
    // this.fetchCategories();

    if (this.props.ui.toaster.isOpenToast) {
      toast.success(this.props.ui.toaster.toastMessage);
    }
  }

  hideModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }


  deleteHandler = (event, sliderpublisher) => {
    this.setState({
      delete_sliderpublisher: {
        id: sliderpublisher.id,
        name: sliderpublisher.name,
        slidebar: sliderpublisher.slidebar,
      }
    }, () => {
      this.setState({ modal: true })
    })
  }

  deleteAction = (event, sliderpublisher) => {
    const content = {
      id: sliderpublisher.id
    }
    deleteSliderPublisher(content).then((res) => {
      if (res.status === "Deleted") {
        this.hideModal();
        const load1 = this.loadSliderPublisher();
        Promise.all([load1]).then(() => {
          console.log("halo")
          toast.success("Slider Deleted");
        })
      }

    })
  }

  onSortByHandler = (val) => {
    this.setState({sortbySelect:val,sliderpublishers: [],loadingdata:true}, () => this.loadSliderPublisher());
  }

  onOrderHandler = (val) => {
    this.setState({orderSelect:val,sliderpublishers: [],loadingdata:true}, () => this.loadSliderPublisher());
  }

  onChangeCategoryHandler = (val) => {
    this.setState({ category_selected: val,sliderpublishers: [],loadingdata:true});
  }

  queryInputChangeHandler = (e) => {
    e.preventDefault();  
    if (this.state.typingTimeout) {
      clearTimeout(this.state.typingTimeout);     
   }
    this.setState({ querysearch: e.target.value, sliderpublishers: [],loadingdata:true,
      typingTimeout: setTimeout(()=> this.loadSlider(), 500)
    });

  }

handleEdit = (id) => {
  console.log("Mau edit id:", id);
  // contoh: redirect ke halaman edit
  this.props.history.push(`/dashboard/slider-publisher/${id}/edit`);
}

handleDelete = (id) => {
  console.log("Mau delete id:", id);
  const content = { id: id };
  deleteSliderPublisher(content).then((res) => {
    if (res.status === "Deleted") {
      toast.success("Slider berhasil dihapus");
      this.setState({ sliderpublishers: [] }, () => this.loadSliderPublisher());
    }
  });
}


  render() {     
    let SliderPublisherList = null;
    let items = null;
    if (this.state.loadingdata) {
      SliderPublisherList = <Table responsive>
        <tbody>
          <LoadingSliderAdmin />
          <LoadingSliderAdmin />
          <LoadingSliderAdmin />
        </tbody>
      </Table>;
    }

    // kalau barangnya kososng
    if (this.state.sliderpublishers.length === 0 && !this.state.loadingdata && this.state.isFetching == false) {
      SliderPublisherList = <div className="product-null-wrapper">
        <div className="image-wrapper">
          <img src="/box.svg" alt="" />
        </div>
        <h2 style={{ marginBottom: '12px' }}>Produk tidak ditemukan</h2>
        <p >Produk kamu muncul di halaman ini. Jika tidak muncul ayo dimunculkan / mulai jualan sekarang!</p>
        <Link to="/dashboard/slider-publisher/add" style={{ marginLeft: '10px' }} href="http://google.com">
          <Button color="primary" style={{ marginBottom: '90px' }} size="bg">
            <i className="nc-icon nc-simple-add"></i> Add Slider
               </Button>
        </Link>
      </div>
    }

    else if (this.state.sliderpublishers.length > 0) {
     items = this.state.sliderpublishers.map((res, key) =>
        <SliderPublishers
          id={res.id}
          sliderpublisher={res}
          key={res.id}
          images={res.slidebar}
          onEdit={() => this.handleEdit(res.id)} 
          onDelete={() => this.handleDelete(res.id)} 
        />
      )

      SliderPublisherList =
      <div>
        <InfiniteScroll
          pageStart={1}      
          // isReverse={true}    
          hasMore={this.state.hasMoreItems}
          loadMore={this.loadSliderPublisher}
          loader={<div style={{textAlign:'center'}}><img src={SpinnerGif} width="100"/> Loading Please Wait ...</div>}
        >
          {items}
        </InfiniteScroll>
      </div>
    }

    return (

      <div className="content">
        <Modal isOpen={this.state.modal} fade={false} toggle={this.hideModal}>
          <ModalHeader>
            Apakah kamu yakin akan menghapus produk ini ?
          </ModalHeader>
          <ModalBody>
            <div className="products-display-container">
              <div className="box-media">
                <div className="product-pict" style={{ background: `url(${this.state.delete_sliderpublisher.picture_url})` }}></div>
              </div>
              <div className="box-short-desc">
                <a href="#">{this.state.delete_sliderpublisher.name}</a>
                {/* <small>Cetakan ke 2</small> */}
                <div className="ellipsis">Hyperlink: <b>{this.state.delete_sliderpublisher?.hyperlink}</b></div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.setState({ modal: false })}>No</Button>
            <Button color="success" onClick={(event) => this.deleteAction(event, this.state.delete_sliderpublisher)}>Yes</Button>
          </ModalFooter>
        </Modal>
        <Row>
          <Col md={12}>
            <div className="">
              <Link to="/dashboard/slider-publisher/add" style={{ marginLeft: '10px' }} href="http://google.com">
                <Button color="primary" size="sm">
                  <i className="nc-icon nc-simple-add"></i> Add Product
               </Button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {/* <Card> */}
            <CardBody>
              {SliderPublisherList}
            </CardBody>
            {/* </Card> */}
          </Col>
        </Row>
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuth: state.authsd.token !== null,
    authRedirectPath: state.authsd.authRedirectPath,
    ui: state.ui
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignUp: () => dispatch(actionCreator.authCheckState()),
    onSetAuthRedirectPath: (path) => dispatch(actionCreator.setAuthRedirectPath(path)),
    setLoading: (data) => dispatch(actionCreator.toggleLoading(data)),
    toggleToaster: (payload) => dispatch(actionCreator.toggleToaster(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SliderPublisher);

